window.onload = function() {
  $(".text-columns-with-images__item-heading, .text-columns-with-images__item-image").click(function(){
		// close any already open first
		$('.modal-show').removeClass('modal-show');

		$(this).parent().find('.text-columns-with-images__item-text').addClass('modal-show');
		// dynamically add a close button
		$(this).parent().find('.text-columns-with-images__item-text').prepend("<span class='close-t-club'>close</span>");

		// close modal
		$(".close-t-club").click(function(){
			$('.modal-show').removeClass('modal-show');
		});
	});
};